import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ChartModule} from "primeng/chart";

import {MenuModule} from "primeng/menu";
import {TableModule} from "primeng/table";
import {Subscription} from "rxjs";
import {LayoutService} from "../../layout/service/app.layout.service";
import {DataService} from "../../service/data.service";
import {PlatformRole, ProjectDescriptorUse} from 'src/app/api/enums';
import {BetaReaderReadingProfileComponent} from "./beta-reader-reading-profile/beta-reader-reading-profile.component";
import {ActivatedRoute} from "@angular/router";
import {BetaReaderProjectMatchesComponent} from "./beta-reader-project-matches/beta-reader-project-matches.component";
import {ProjectDisplayComponent} from "../project-display/project-display.component";
import {ProjectCountComponent} from "../stat-blocks/project-count/project-count.component";
import {ProjectWordCountComponent} from "../stat-blocks/project-word-count/project-word-count.component";
import {UserCountComponent} from "../stat-blocks/user-count/user-count.component";
import {PlaceholderComponent} from "../stat-blocks/placeholder/placeholder.component";
import {Button} from "primeng/button";
import {PlatformUser} from "../../api/db/entities/PlatformUser";
import {BetaReaderProfile} from "../../api/db/entities/BetaReaderProfile";
import {BetaReaderProject} from "../../api/db/entities/BetaReaderProject";
import {Project} from "../../api/db/entities/Project";
import { DialogModule } from 'primeng/dialog';
import { ProjectMatchType } from 'src/app/api/db/entities/ProjectMatchType';

@Component({
    templateUrl: './beta-reader-dashboard.component.html',
    imports: [
    BetaReaderReadingProfileComponent,
    TableModule,
    MenuModule,
    ChartModule,
    BetaReaderProjectMatchesComponent,
    ProjectDisplayComponent,
    ProjectCountComponent,
    ProjectWordCountComponent,
    UserCountComponent,
    PlaceholderComponent,
    Button,
    DialogModule,
    CommonModule,
]
})
export class BetaReaderDashboardComponent implements OnDestroy {
    protected dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    layoutService = inject(LayoutService);

    protected platformUser: PlatformUser;
    isAllowed: boolean = false;
    protected betaReader: BetaReaderProfile;
    protected selectedBRProject: BetaReaderProject;
    protected selectedProjectMatch: ProjectMatchType;
    protected uuid: string;
    private dialogVisible: boolean = false;


    constructor() {
        this.subscriptions.push(this.dataService.userObs.subscribe(u => {
            this.platformUser = u;
            this.isAllowed = u.roles.includes(PlatformRole.BETAREADER.valueOf());
        }));
        this.subscriptions.push(this.dataService.betaReader.subscribe(u => {
            console.log('I HAVE READER', u);
            this.betaReader = u;
            this.subscriptions.push(this.route.params.subscribe(async params => {
                console.log(params);
                this.uuid = params['project'];

                if (this.uuid !== "new") {
                    this.selectedBRProject = this.betaReader.betaReaderProjects.find(p => p.uuid === this.uuid);

                    const prj: Project = this.dataService.getProjectForUUID(this.selectedBRProject.uuid);
                    this.dataService.setSelectedProject(this.selectedBRProject);

                    this.selectedProjectMatch = this.dataService.getPMTByProject(prj);
                    
                    /*this.selectedProjectMatch = {
                        //author: prj.usesPenName?prj.penNameGivenName+' '+prj.penNameSurname:'',
                        //betaReaderProject: this.selectedBRProject,
                        //categories: null,
                        project: prj,
                        matchScore: 0,
                        //title: prj.title?prj.title:'',
                        betaReader: this.betaReader,
                        projectMatchStatus: null
                    };*/

                    //console.log("selectedBRProject: ", this.selectedBRProject, "selectedProjectMatch: ", this.selectedProjectMatch, "UUID: ", this.uuid);
                } else {
                    this.selectedBRProject = undefined;
                    this.selectedProjectMatch = undefined;
                    this.dataService.setSelectedProject(undefined);
                }
            }));
        }));
    }

    private subscriptions: Subscription[] = [];
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    }

    protected readonly ProjectDescriptorUse = ProjectDescriptorUse;

    showDialog() {
        this.dialogVisible = true;
    }

    hideDialog(){
        this.dialogVisible = false;
    }

    projectDebug(){
        console.log(this.selectedProjectMatch);
    }

    saveAndRoute(){
        this.selectedBRProject.lastInfoRead = new Date();
        this.dataService.saveBetaReaderProject(this.selectedBRProject);
        this.dataService.switchToEditLayout();
    }


}
